// extracted by mini-css-extract-plugin
export default {"thumbnails":"GallerySlider_thumbnails__FtGWT","arrow":"GallerySlider_arrow__uX7eJ","left":"GallerySlider_left__tDXH-","right":"GallerySlider_right__HXyqw"};